module.exports = __webpack_public_path__ + "static/media/bocconi-logo.bd09f5c6.jpg";